subscription newConversation($teamId: ID!, $tz: String) {
  newConversation(teamId: $teamId) {
    id
    hasUnreads
    formattedMessagedAt(tz: $tz)
    mostRecentCommunication
    homeNumber {
      id
      label
      formattedNumber
    }
    messagedAt
    teacherPhoneNumber {
      id
    }
    team {
      id
    }
    hasUnreads
    updatedAt(tz: $tz)
  }
}
